import React from "react";

function DashboardLayout({ onLogout }) {
  return (
    <div style={{
      background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
      padding: "1.5rem 2rem",
      borderRadius: "16px",
      marginBottom: "2rem",
      boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}>
      <div>
        <h1 style={{ margin: 0, color: "#fff", fontSize: "1.6rem", fontWeight: 700, letterSpacing: "-0.5px" }}>
          KIWO Dashboard
        </h1>
        <p style={{ margin: "4px 0 0", color: "#94a3b8", fontSize: "0.85rem" }}>
          Monitoring en temps réel
        </p>
      </div>
      <button
        onClick={onLogout}
        style={{
          padding: "0.6rem 1.2rem",
          backgroundColor: "rgba(255,255,255,0.1)",
          color: "#e2e8f0",
          border: "1px solid rgba(255,255,255,0.15)",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "0.875rem",
          fontWeight: 500,
          transition: "background 0.2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.2)")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)")}
      >
        Déconnexion
      </button>
    </div>
  );
}

export default DashboardLayout;
